export class CaseInsensitiveURLSearchParams {
  constructor(queryStr) {
    const urlParams = new URLSearchParams(queryStr);
    this.urlParams = new URLSearchParams('');
    for (const key of urlParams.keys()) {
      const value = urlParams.get(key);
      const newKey = key.toLowerCase();
      this.urlParams.set(newKey, value);
    }
  }

  get(paramName = '') {
    // custom get method code here
    return this.urlParams.get(paramName.toLowerCase());
  }

  delete(paramName = '') {
    return this.urlParams.delete(paramName.toLowerCase());
  }

  reconstruct() {
    const mark = '?';
    let res = mark;
    for (const key of this.urlParams.keys()) {
      res += (res === mark ? '' : '&') + key + '=' + this.get(key);
    }
    return res === mark ? '' : res;
  }
}
